import React, { useState } from "react"
import TableColumnModal    from "./table_column_modal"

const TableDropdown = ({
  columns      = [],
  tables       = [],
  openTable,
  showAllColumns,
  saveTable,
  userCanSave,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const onSave = (selectedColumns, name) => {
    saveTable(selectedColumns, name)
    setIsOpen(false)
  }

  return (
    <>
      { tables.length > 0 ?
          <span className = "dropdown">
            <button
              data-toggle = "dropdown"
              className   = "btn btn-primary small btn-sm mr-2"
            >
              <i className = "fa fa-table" /> {I18n.t("export.tables")}
            </button>

            <div className = "dropdown-menu">
              <div
                className = "dropdown-item"
                onClick   = {showAllColumns}
              >
                {I18n.t("export.all_columns")}
              </div>

              <hr className = "m-0" />

              { tables.map(table => (
                <div
                  key       = {table.id}
                  className = "dropdown-item"
                  onClick   = {() => openTable(table)}
                >
                  {table.name} {table?.published ? "" : I18n.t("export.not_published")}
                </div>
              ))}

              { userCanSave &&
                <>
                  <hr className = "m-0" />
                  <div
                    className = "dropdown-item"
                    onClick   = {() => setIsOpen(true)}
                  >
                    {I18n.t("export.add_table")}
                  </div>
                </>
              }
            </div>
          </span>
          :
          <button
            className = "btn btn-primary small btn-sm mr-2"
            onClick   = {() => setIsOpen(true)}
          >
            <i className = "fa fa-table" /> {I18n.t("export.tables")}
          </button>
      }

      { userCanSave &&
        <TableColumnModal
          id          = "new-table-modal"
          columns     = {columns}
          isOpen      = {isOpen}
          setIsOpen   = {setIsOpen}
          title       = {I18n.t("export.add_table")}
          confirmText = {I18n.t("export.save")}
          onConfirm   = {onSave}
        />
      }
    </>
  )
}

export default TableDropdown
